import APIService from '@/services/api.service';
import UserService from '@/services/user.service';
import Q from 'q';

class DocumentSharingService {

    constructor() {}

    postLimitedInvitation(setId, documents, recipients) {

        var invitationURL = '';

        return queueInvitation()
            .then(attachDocuments)
            .then(attachRecipients)
            .then(sendAnnouncement);

        function queueInvitation() {
            var settings = APIService.defaultSettingsPlus({
                'url': APIService.baseURL + '/api/v1/documentsets/' + setId + '/limitedinvitations',
                'method': 'POST',
                'data': '{"limitedinvitation":{"hidden":false}}',
                'dataType': 'text',
                'processData': false,
                'contentType': 'application/json',
                statusCode: {
                    201: function(data, status, xhr) {
                        invitationURL = xhr.getResponseHeader('Location');
                    }
                }
            });
            return APIService.waitFor( Q($.ajax(settings)) );
        }

        function attachDocuments(response) {
            var dfd = [];
            for (var i = documents.length - 1; i >= 0; i--) {
                dfd.push(queueDocument(documents[i].id));
            }
            return Q.all(dfd);
        }

        function attachRecipients(response) {
            var dfd = [];
            for (var i = 0; i < recipients.length; i++) {
                dfd.push(queueRecipient(recipients[i].email));
            }
            return Q.all(dfd);
        }

        function sendAnnouncement() {
            return queueAnnouncement();
        }

        function queueDocument(documentId) {
            var settings = APIService.defaultSettingsPlus({
                'url': APIService.baseURL + invitationURL + '/documentlinks',
                'method': 'POST',
                'data': '{"limited_invitation_document_link":{"documentId":' + documentId + '}}',
                'processData': false,
                'dataType': 'text',
                'contentType': 'application/json'
            });
            return APIService.waitFor( Q($.ajax(settings)) );
        }

        function queueRecipient(email) {
            var settings = APIService.defaultSettingsPlus({
                'url': APIService.baseURL + invitationURL + '/emails',
                'method': 'POST',
                'data': '{"limited_invitation_email":{"emailAddress":"' + email + '"}}',
                'processData': false,
                'dataType': 'text',
                'contentType': 'application/json'
            });
            return APIService.waitFor( Q($.ajax(settings)) );
        }

        function queueAnnouncement() {
            var settings = APIService.defaultSettingsPlus({
                'url': APIService.baseURL + invitationURL + '/announcements',
                'method': 'POST',
                'data': '{"limited_invitation_announcement":{}}',
                'processData': false,
                'dataType': 'text',
                'contentType': 'application/json'
            });
            return APIService.waitFor( Q($.ajax(settings)) );
        }

    }

}

export default new DocumentSharingService();


// WEBPACK FOOTER //
// ./src/services/document-sharing.service.js